module.exports = __webpack_public_path__ + "static/media/Zinsrechner.73bb0790.svg";